import { useMemo } from 'react';
import { useAuth } from '../auth';
import { useSettingsStore } from '../stores/settingsStore';
import { useCalendarSharingStore } from '../stores/calendarSharingStore';
import { useEnsureSharing } from './team/useEnsureSharing';
import { isAppointmentType, resolveBooking, type BookingResolution } from './booking';

/**
 * Regola "Fissare gli appuntamenti" per chi sta compilando il modulo (Impostazioni › Calendario).
 * null = nessuna regola per i suoi ruoli, tipo non appuntamento o dati non ancora caricati: come prima.
 * Persone e ruoli arrivano dai calendari condivisi, gia' caricati per la vista Team.
 */
export function useBookingRule(type: string | null | undefined, leadOwnerId?: string | null): BookingResolution | null {
  const rules = useSettingsStore(s => (s.settings as any)?.calendar_settings?.booking?.rules);
  // Persone e ruoli si caricano solo se c'e' una regola e si sta fissando un appuntamento
  useEnsureSharing(!!rules?.length && isAppointmentType(type));
  const { user } = useAuth();
  const people = useCalendarSharingStore(s => s.people);
  return useMemo(
    () => resolveBooking({ meId: user?.id ?? null, people, rules, type, leadOwnerId }),
    [user?.id, people, rules, type, leadOwnerId],
  );
}
